import { NextRouter } from "next/router";

export const checkIsCorrectPath = (router: NextRouter, ...paths) => {
  return paths.reduce((a, b) => {
    if (a === undefined || a === false) {
      return router.asPath === b;
    }
    return a;
  }, undefined);
};
